import { LitElement, html, css, nothing } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import type { Plan } from '../../schemas/plan.js'

@customElement('decision-framework-view')
export class DecisionFrameworkView extends LitElement {
  @property({ type: Object }) plan: Plan | null = null

  static override styles = css`
    :host {
      display: block;
    }
    .section-title {
      font-size: 16px;
      font-weight: 600;
      margin: 0 0 12px;
    }
    .decision-table-wrapper {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
      margin: 0 -16px;
      padding: 0 16px;
    }
    .decision-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 13px;
      table-layout: fixed;
    }
    .decision-table th,
    .decision-table td {
      padding: 8px 10px;
      text-align: left;
      border-bottom: 1px solid var(--cairn-border-color, #ccc);
      vertical-align: top;
      word-wrap: break-word;
    }
    .decision-table th {
      font-weight: 600;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      color: var(--cairn-text-secondary-color, #666);
    }
    .decision-table th.col-factor {
      width: 25%;
    }
    .decision-table th.col-green {
      color: #2e7d32;
    }
    .decision-table th.col-yellow {
      color: #f9a825;
    }
    .decision-table th.col-red {
      color: #c62828;
    }
    .decision-table td.cell-green {
      background: rgba(46, 125, 50, 0.08);
    }
    .decision-table td.cell-yellow {
      background: rgba(249, 168, 37, 0.08);
    }
    .decision-table td.cell-red {
      background: rgba(198, 40, 40, 0.08);
    }
    .decision-table tr:last-child td {
      border-bottom: none;
    }
    .rules-row td {
      font-weight: 600;
      font-size: 12px;
      border-top: 2px solid var(--cairn-border-color, #ccc);
    }
    .rules-row .rule-green {
      color: #2e7d32;
    }
    .rules-row .rule-yellow {
      color: #f9a825;
    }
    .rules-row .rule-red {
      color: #c62828;
    }
    .empty-note {
      color: var(--cairn-text-secondary-color, #666);
      font-style: italic;
      padding: 16px 0;
    }
  `

  override render() {
    const factors = this.plan?.decisionFactors
    if (!factors || factors.length === 0) return nothing

    return html`
      <h2 class="section-title">Decision Framework</h2>
      <div class="decision-table-wrapper">
        <table class="decision-table">
          <thead>
            <tr>
              <th class="col-factor">Factor</th>
              <th class="col-green">Go</th>
              <th class="col-yellow">Caution</th>
              <th class="col-red">No-Go</th>
            </tr>
          </thead>
          <tbody>
            ${factors.map(
              f => html`
                <tr>
                  <td>${f.name}</td>
                  <td class="cell-green">${f.green || '-'}</td>
                  <td class="cell-yellow">${f.yellow || '-'}</td>
                  <td class="cell-red">${f.red || '-'}</td>
                </tr>
              `
            )}
            <tr class="rules-row">
              <td></td>
              <td class="rule-green">All Green = Go</td>
              <td class="rule-yellow">3 Yellow = No Go!</td>
              <td class="rule-red">1 Red = No Go!</td>
            </tr>
          </tbody>
        </table>
      </div>
    `
  }
}
